var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-dd550b242a3b6b8a5a6248c8d85caec3.svg#icon-whatsapp-share-e5876';
                    var viewUrl = 'svg-sprite-dd550b242a3b6b8a5a6248c8d85caec3.svg#view-icon-whatsapp-share-e5876';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: 'undefined',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };